import { AutocompleteInput, useGetList } from 'react-admin';
import { useState, useMemo } from 'react';

export const BatchAutocomplete = (props: any) => {
    const [searchText, setSearchText] = useState('');
    const [selectedItem, setSelectedItem] = useState<any>(null);

    const { data, isLoading } = useGetList('batches', {
        pagination: { page: 1, perPage: 50 },
        filter: searchText && { title: searchText },
    });

    const choices = useMemo(() => {
        const dataArray = data || [];
        if (selectedItem && !dataArray.find((item: any) => item.id === selectedItem.id)) {
            return [selectedItem, ...dataArray];
        }
        return dataArray;
    }, [data, selectedItem]);

    return (
        <AutocompleteInput
            {...props}
            source={props.source || 'batchId'}
            fullWidth
            label="Batch"
            choices={choices}
            optionText="title"
            optionValue="id"
            loading={isLoading}
            setFilter={value => setSearchText(value)}
            onChange={value => {
                const selected = choices.find((item: any) => item.id === value);
                if (selected) {
                    setSelectedItem(selected);
                }
                if (props.onChange) {
                    props.onChange(value);
                }
            }}
            debounce={500}
            shouldRenderSuggestions={(val: string) => {
                return val.trim().length >= 0;
            }}
        />
    );
};
